import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/ClientRoot.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/layout.css");
